import styled from 'styled-components';

import { IconButton } from '#src/atoms/buttons/IconButton/index.tsx';
import { FontAwesomeIcon } from '#src/atoms/icons/index.tsx';
import { iconThumbtack } from '#src/atoms/icons/system/iconThumbtack.ts';
import { laptopAndAbove } from '#src/style/mediaQuery.ts';

const StyledPinButton = styled(IconButton)`
  transform: rotate(45deg);
  align-self: center;
  @media ${laptopAndAbove} {
    align-self: flex-start;
  }
`;

type Props = {
  onClick: () => void;
  isPinned: boolean;
};

export const PinButton = ({ onClick, isPinned }: Props) => (
  <StyledPinButton
    size="compact"
    onClick={onClick}
    color={isPinned ? 'secondary' : 'quaternary'}
  >
    <FontAwesomeIcon icon={iconThumbtack} size="xs" />
  </StyledPinButton>
);
